import { formOptions } from '@tanstack/react-form';
import { z } from 'zod';

export const linkExpireModeSchema = z.enum([
  'never',
  '7days',
  '30days',
  '60days',
  '90days',
]);

export type LinkExpireMode = z.infer<typeof linkExpireModeSchema>;

export const EXPIRE_MODE_DAYS: Record<LinkExpireMode, number> = {
  never: -1,
  '7days': 7,
  '30days': 30,
  '60days': 60,
  '90days': 90,
};

export const sharedLinkFormSchema = z.object({
  sharedLinkId: z.string(),
  workspaceId: z.string(),
  targetId: z.string(),
  targetLink: z.string(),
  sharedLink: z.string(),
  isPublic: z.boolean(),
  linkExpireMode: linkExpireModeSchema,
  linkExpireEnabled: z.boolean(),
  password: z.string().min(8).max(50).optional(),
  passwordEnabled: z.boolean(),
});

export type SharedLinkFormData = z.infer<typeof sharedLinkFormSchema>;

export type SharedLinkFormDefaults = {
  sharedLinkId: string;
  workspaceId: string;
  targetId: string;
  targetLink: string;
  sharedLink: string;
  isPublic: boolean;
  linkExpireMode: LinkExpireMode;
  linkExpireEnabled: boolean;
  password?: string;
  passwordEnabled: boolean;
};

export const sharedLinkFormDefaultValues: SharedLinkFormDefaults = {
  sharedLinkId: '',
  workspaceId: '',
  targetId: '',
  targetLink: '',
  sharedLink: '',
  isPublic: true,
  linkExpireMode: '7days',
  linkExpireEnabled: false,
  password: '',
  passwordEnabled: false,
};

export const sharedLinkFormOptions = formOptions({
  defaultValues: sharedLinkFormDefaultValues,
});
